<template>
  <div class="card">
    <div
      class="card-header d-flex align-items-center justify-content-between pb-3"
    >
      <!-- Título y botón -->
      <h4 class="mb-0 text-primary">Categoría</h4>
      <Preloader :visible="cargando" />
      <button class="btn btn-primary d-flex align-items-center gap-2" @click="nuevoItem">
        <i class="fas fa-plus"></i>
        <span>Nuevo</span>
      </button>
    </div>
    <!-- Cuerpo de la tarjeta con la tabla de categorías -->
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-4">
        <table class="table table-bordered table-striped mb-0" ref="itemtabla">
          <thead>
            <tr>
              <th class="text-center px-3 py-2">ID</th>
              <th class="text-center px-3 py-2">Nombre</th>
              <th class="text-center px-3 py-2">Descripción</th>
              <th class="text-center px-3 py-2">Estado</th>
              <th class="text-center px-3 py-2">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(categoria, index) in categorias" :key="index">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-start">{{ categoria.nombre }}</td>
              <td class="text-start">{{ categoria.descripcion }}</td>
              <td class="text-center">
                <span class="badge badge-sm" :class="categoria.estado ? 'bg-success' : 'bg-danger'">
                  {{ categoria.estado ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td class="text-center">
                <button @click="verCategoria(categoria)" class="badge badge-sm bg-gradient-success">
                  <i class="far fa-eye" aria-hidden="true"></i>
                </button>
                <button
                  @click="editarCategoria(categoria)"
                  class="badge badge-sm bg-gradient-warning"
                >
                  <i class="far fa-edit" aria-hidden="true"></i>
                </button>
                <!-- Activar y desactivar estado de Categoria-->
                <button @click="desactivarCategoria(categoria.id)" :class="[
                  'badge badge-sm',
                  categoria.estado === 1
                    ? 'bg-gradient-danger'
                    : 'bg-gradient-info'
                ]" :title="categoria.estado === 1 ? 'Desactivar' : 'Activar'">
                  <i :class="[
                    'fa-lg',
                    categoria.estado === 1
                      ? 'far fa-trash-alt'
                      : 'far fas fa-check'
                  ]" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal para crear o editar una categoría -->
    <div class="modal fade" id="principalModal" tabindex="-1" aria-labelledby="principalModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <!-- Cabecera del modal -->
          <div class="modal-header">
            <h5 class="modal-title" id="principalModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              @click="closeModal"></button>
          </div>
          <!-- Cuerpo del modal -->
          <div class="modal-body">
            <form id="premioForm">
              <div class="mb-3">
                <label for="nombre" class="form-label">Nombre de Categoría</label>
                <input
                  type="text"
                  class="form-control"
                  id="nombre"
                  v-model="form.nombre"
                />
                <div class="text-danger">{{ formErrors.nombre }}</div>
              </div>
              <div class="mb-3">
                <label for="descripcion" class="form-label">Descripción</label>
                <textarea
                  class="form-control"
                  id="descripcion"
                  v-model="form.descripcion"
                ></textarea>
                <div class="text-danger">{{ formErrors.descripcion }}</div>
              </div>
              <div class="mb-3">
                <label for="cliente" class="form-label">Cliente</label>
                <v-select :options="clientes" label="nombres" :reduce="cliente => cliente.id" v-model="form.id_cliente"
                  placeholder="Seleccione un cliente">
                </v-select>
                <div class="text-danger">{{ formErrors.id_cliente }}</div>
              </div>
              <div class="mb-3">
                <label for="imagen" class="form-label">Imagen</label>
                <input
                  type="file"
                  class="form-control"
                  @change="handleFileUpload"
                />
                <div class="text-danger">{{ formErrors.imagen }}</div>
                <div v-if="form.imagen" class="mt-2">
                  <img
                    :src="form.imagen"
                    alt="Imagen de la categoria"
                    width="100"
                  />
                </div>
              </div>
            </form>
          </div>

          <!-- Pie del modal -->
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="closeModal"
            >
              Cerrar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="guardarCategoria"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preloader from "../components/Preloader.vue";
import CategoriaService from "../../services/CategoriaService";
import Clienteservice from "../../services/Clienteservice";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "Categorias",
  data() {
    return {
      categorias: [],
      clientes: [], // Lista de clientes
      cargando: false,
      form: {
        nombre: "",
        imagen: "",
        descripcion: "",
        estado: 1,
        id_cliente: null, // Nuevo campo para el cliente
      },
      formErrors: {},
      file: null,
      modalTitle: "",
      currentCategoriaId: "",
      prevImage: "", //Imagen previa
      imageChanged: false, //Contorlador para cambio de imagen
    };
  },
  created() {
    this.fetchCategorias();
    this.fetchClientes(); // Cargar clientes al iniciar
  },
  components: {
    Preloader,
    vSelect,
  },
  methods: {
    async fetchCategorias() {
      try {
        this.cargando = true;
        const response = await CategoriaService.getCategoriasActivas();
        this.categorias = response.data.data;
        console.log(this.categorias);
      } catch (error) {
        console.error("Error fetching categorias:", error);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al cargar las categorías.",
        });
      } finally {
        this.cargando = false;
      }
    },
    async fetchClientes() {
            try {
                this.cargando = true;
                const response = await Clienteservice.getClientes();
                // 1) Garantizar array aunque venga un solo objeto
                let data = response.data.data;
                let clientesArr = Array.isArray(data) ? data : [data];

                // 2) Filtrar según rol
                const usuario = JSON.parse(localStorage.getItem("user")) || {};
                const esSuperAdmin = usuario.tipo_cliente === "SuperAdmin";
                this.clientes = esSuperAdmin
                    ? clientesArr
                    : clientesArr.filter(c => c.id === usuario.id_cliente);

            } catch (error) {
                console.error("Error fetching clientes:", error);
                this.$swal({
                    icon: "error",
                    title: "Error",
                    text: "Hubo un error al cargar los clientes.",
                });
            } finally {
                this.cargando = false;
            }
        },
    getClienteNombre(idCliente) {
      const cliente = this.clientes.find((c) => c.id === idCliente);
      return cliente ? cliente.nombres : "Sin cliente";
    },
    verCategoria(categoria) {
      const clienteNombre = this.getClienteNombre(categoria.id_cliente);
      const detalles = `
      <div style="display: flex; flex-wrap: wrap;">
        <div style="flex: 1; min-width: 50%; text-align: left; padding-right: 10px;">
          <p><strong>Nombre:</strong> ${categoria.nombre}</p>
          <p><strong>Descripción:</strong> ${categoria.descripcion}</p>
          <p><strong>Cliente:</strong> ${clienteNombre}</p>
        </div>
        <div style="flex: 1; min-width: 50%; text-align: left; padding-left: 10px;">
          <p><strong>Imagen:</strong></p>
          <img src="${categoria.imagen}" alt="${categoria.nombre}" width="100" />
        </div>
      </div>
      `;
      this.$swal({
        icon: "info",
        title: "Detalles de la categoría",
        html: detalles,
      });
    },

    //Funcion de Activar y Desactivar Categorias
    async desactivarCategoria(id) {
      try {
        const cat = this.categorias.find(c => c.id === id);
        if (!cat) return;

        const resp = await CategoriaService.desactivarCategoria(id);
        cat.estado = cat.estado === 1 ? 0 : 1;

        this.$swal({
          icon: 'success',
          title: cat.estado === 1
            ? 'Categoría activada'
            : 'Categoría desactivada',
          text: resp.data.message || '',
        });
      } catch (error) {
        console.error('Error cambiando estado:', error);
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cambiar el estado.',
        });
      }
    },

    editarCategoria(categoria) {
      this.modalTitle = "Editar Categoría";
      this.currentCategoriaId = categoria.id;
      this.form = {
        nombre: categoria.nombre,
        descripcion: categoria.descripcion,
        imagen: categoria.imagen,
        estado: categoria.estado,
        id_cliente: categoria.id_cliente, //Agregar id_cliente
      };
      this.prevImage = categoria.imagen || "";
      this.showModal();
    },
    async guardarCategoria() {
      const formData = new FormData();
      formData.append("nombre", this.form.nombre);
      formData.append("descripcion", this.form.descripcion);
      formData.append("id_cliente", this.form.id_cliente);
      formData.append("imagen", this.form.imagen); // agrega imagen al form
      formData.append("estado", this.form.estado);
      if (this.currentCategoriaId && this.imageChanged) {
        formData.append("prevImage", this.prevImage || "");
      }
      this.cargando = true;
      try {
        if (this.currentCategoriaId) {
          formData.append("_method", "PUT");
          await CategoriaService.updateCategoria(
            this.currentCategoriaId,
            formData,
          );
          this.$swal({
            icon: "success",
            title: "Categoría Actualizada",
            text: "La categoría ha sido actualizada exitosamente.",
          }).then(() => {
            this.fetchCategorias();
            location.reload();
            this.closeModal();
          });
        } else {
          await CategoriaService.createCategoria(formData);
          this.$swal({
            icon: "success",
            title: "Categoría Registrada",
            text: "La categoría ha sido registrada exitosamente.",
          }).then(() => {
            this.fetchCategorias();
            location.reload();
            this.closeModal();
          });
        }
      } catch (error) {
        if (error.response && error.response.data.errors) {
          this.formErrors = error.response.data.errors;
          console.error("Errores en la validación de campos:", this.formErrors);
          this.$swal({
            icon: "error",
            title: "Error en los campos",
            text: "Por favor, revisa los errores en los campos y vuelve a intentarlo.",
          });
        } else {
          console.error("Error guardando la categoria:", error);
          this.$swal({
            icon: "error",
            title: "Error inesperado",
            text: "Hubo un error al guardar la categoria.",
          });
        }
      } finally {
        this.cargando = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.file = file;
      //Convierte la imagen en base64 para pasarlo al backend
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.imagen = e.target.result;
        this.imageChanged = true;
      };
      reader.readAsDataURL(file);
    },
    nuevoItem() {
      this.modalTitle = "Nueva Categoría";
      this.currentCategoriaId = null;
      this.imageChanged = false;
      this.prevImage = "";
      this.form = {
        nombre: "",
        imagen: "",
        descripcion: "",
        estado: 1,
        id_cliente: null,
      };
      this.showModal();
    },
    showModal() {
      const modal = document.getElementById("principalModal");
      modal.classList.add("show");
      modal.style.display = "block";
      modal.setAttribute("aria-modal", "true");
      modal.removeAttribute("aria-hidden");
    },
    closeModal() {
      const modal = document.getElementById("principalModal");
      modal.classList.remove("show");
      modal.style.display = "none";
      modal.setAttribute("aria-hidden", "true");
      modal.removeAttribute("aria-modal");
      this.formErrors = {};
      this.prevImage = "";
      this.imageChanged = false;
    },
  },
};
</script>

<style scoped>
/* Ajustes de la tabla para pantallas pequeñas */
.table {
  font-size: 0.9rem;
}

@media (max-width: 767px) {
  .table {
    font-size: 0.8rem;
  }
}

.modal-dialog {
  max-width: 500px;
  margin: 1.75rem auto;
}

@media (max-width: 768px) {
  .modal-dialog {
    max-width: 95%;
  }
}

/* Estilos para vue-select */
.v-select {
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
}

.v-select:focus-within {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
</style>
